















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import FilterIcon from '@/components/icons/Filter.vue';

@Component({
  components: {
    FilterIcon
  }
})
export default class CustomSelect extends Vue {
  @Prop(String) placeholder!: string;
  @Prop(String) value!: string;
  @Prop({ default: false }) menuOpened!: boolean;
  @Prop({ default: false }) transparent!: boolean;
  @Prop({ default: false }) formStyle!: boolean;
  @Prop() error!: string;
  @Prop({ default: false }) highlightError!: boolean;
  @Prop({ default: false }) secondary!: boolean;
  @Prop({ default: false }) isFilter!: boolean;
  @Prop({ default: 0 }) qtdSelected!: number;
  @Prop({ default: false }) showQtdSelected!: boolean;

  toggleMenu(event: Event) {
    this.$emit('menuChanged', !this.menuOpened);
  }
}
